"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _marketingDotComNav = require("marketing-dot-com-nav");

var _styledComponents = require("styled-components");

var _layout = require("../../constants/layout");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .hsg-footer__layout {\n    max-width: ", "px !important;\n    padding: 0 !important;\n\n    @media (min-width: 768px) {\n      padding: 0 ", "px !important;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalFooterStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), _layout.MAIN_SECTION_MAX_WIDTH, _layout.MAIN_SECTION_PADDING_X);

var MarketingNavFooter = function MarketingNavFooter(_ref) {
  var lang = _ref.lang;
  var FooterComponent = (0, _react.useMemo)(function () {
    if (lang === 'ja') {
      return _marketingDotComNav.Footer.jp;
    }

    return _marketingDotComNav.Footer[lang] || _marketingDotComNav.Footer.en;
  }, [lang]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(GlobalFooterStyle, null), _react.default.createElement(FooterComponent, null));
};

MarketingNavFooter.propTypes = {
  lang: _propTypes.default.string
};
MarketingNavFooter.defaultProps = {
  lang: 'en'
};
var _default = MarketingNavFooter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/nav/MarketingNavFooter.js
// module id = 1178
// module chunks = 212